import _startCase from 'lodash/startCase';

import { INTERNAL_FORM_FIELD_TYPES } from '../../../../../../constants/form';

export function isPlaceholderShown({ type } = {}) {
  return ![INTERNAL_FORM_FIELD_TYPES.FileUpload, INTERNAL_FORM_FIELD_TYPES.MarkdownText].includes(
    type,
  );
}

export function isLabelShown({ type } = {}) {
  return ![INTERNAL_FORM_FIELD_TYPES.MarkdownText].includes(type);
}

export function isRequiredShown({ type } = {}) {
  return ![INTERNAL_FORM_FIELD_TYPES.MarkdownText].includes(type);
}

export function formatFieldType(type) {
  return `${_startCase(type)} Field`;
}

export function isFileUploadType(type) {
  return type === INTERNAL_FORM_FIELD_TYPES.FileUpload;
}
